import { DayHeuristicsWeights, MealOfDayHeuristicsWeights, RecommenderSettings } from '@/api/types'
import React from 'react'
import { HeuristicSlider } from './HeuristicSlider'
import { Label } from '@/components/Label'
import { Switch } from '@/components/Switch'

type Props = {
  recommenderSettings: RecommenderSettings
  setRecommenderSettings: (settings: RecommenderSettings) => void
  setDayImprovement: (value: boolean) => void
} & React.HTMLAttributes<HTMLDivElement>

export function DayHeuristics({
  recommenderSettings,
  setRecommenderSettings,
  setDayImprovement,
  ...props
}: Props) {
  function setHeuristicWeight(key: keyof DayHeuristicsWeights, value: number) {
    setRecommenderSettings({
      ...recommenderSettings,
      dayHeuristicsWeights: {
        ...recommenderSettings.dayHeuristicsWeights,
        [key]: value,
      },
    })
  }

  return (
    <div {...props}>
      <Switch
        isSelected={recommenderSettings.runDayImprovement}
        onChange={setDayImprovement}
        style={{ marginBottom: '10px' }}>
        Run day improvement
      </Switch>
      <Label>Day heuristics</Label>
      <HeuristicSlider
        label="NUTRITIONAL_DEVIATION"
        value={recommenderSettings.dayHeuristicsWeights.NUTRITIONAL_DEVIATION}
        onChange={(value) => {
          setHeuristicWeight('NUTRITIONAL_DEVIATION', value)
        }}
        isDisabled={!recommenderSettings.runDayImprovement}
      />
      <HeuristicSlider
        label="FRUIT_VARIETY"
        value={recommenderSettings.dayHeuristicsWeights.FRUIT_VARIETY}
        onChange={(value) => {
          setHeuristicWeight('FRUIT_VARIETY', value)
        }}
        isDisabled={!recommenderSettings.runDayImprovement}
      />
    </div>
  )
}
